import '../scripts/components/custom-select.js';
import '../scripts/components/personalize-product.js';

console.log('personalization.bundle.js loaded');
